import React, { useEffect, useRef } from "react";
import { useIsMobile } from "../../../device/selectors";
import { useSmarticoRaffleDrawById, useSmarticoRaffleIsLoading } from "../../store";
import { SmarticoRaffleDrawIds } from "../../interfaces/SmarticoRaffleDrawIds";
import { Steps } from "../../../../../(custom-header)/spring-daily-raffle/components/Steps";
import { useTimer } from "../../../../../hooks/useTimer";
import ChevronsRightIcon from "@/app/shared-components/icons/ChevronsRightIcon";
import { useRaffleContext } from "../../../../../(custom-header)/spring-daily-raffle/context";
import { TabKey } from "./AllPrizesModal/utils/types";

const ButtonBanner = () => {
  const { viewAllPrizes } = useRaffleContext();
  return (
    <button
      onClick={() => {
        viewAllPrizes(TabKey.PREMII_ZILNIC);
      }}
      className="theme-btn theme-btn-primary theme-btn-md lg:theme-btn-2lg min-w-[188px] lg:min-w-[220px] uppercase">
      Get draw tickets
      <ChevronsRightIcon className={"size-4 lg:size-6 shrink-0"} variant={3} />
    </button>
  );
};

const TombolaTopRender = (props: any) => {
  const isMobile = useIsMobile();
  const { isEndState } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const dailyDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.HOURLY_DRAW);
  const grandDraw = useSmarticoRaffleDrawById(SmarticoRaffleDrawIds.GRAND_DRAW);
  const isRaffleLoading = useSmarticoRaffleIsLoading();
  const draw = dailyDraw.execution_ts >= Date.now() ? dailyDraw : grandDraw;

  const timer = useTimer(String(draw.id), draw.execution_ts, undefined, "millisecond");
  const milisecondsT = Math.floor(timer.milliseconds / 10)
    .toString()
    .padStart(2, "0");
  const daysCount = timer.days?.replace(/^0+/, "") || "0";
  const daysLabel = `${daysCount} ${Number(daysCount) === 1 ? "DAY" : "DAYS"}`;

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(entries => {
      const showStickyHeaderRaffle = new CustomEvent("RAFFLE_TOGGLE_STICKY_HEADER", {
        detail: entries[0].isIntersecting,
      });
      window.dispatchEvent(showStickyHeaderRaffle);
    });

    intersectionObserver.observe(containerRef.current);

    return () => {
      intersectionObserver.disconnect();
    };
  }, []);
  return (
    <div
      ref={containerRef}
      className={`px-3 lg:px-6 lg:pt-[123px] relative w-full ${isEndState ? "pb-[192px] lg:pb-[269px]" : "pb-[68px] lg:pb-[141px]"}`}>
      <div className={"w-full banner-christmas-aspect-ratio lg:hidden"} />
      <img
        src={
          isMobile
            ? "/assets/images/big-7-draws/banner-halloween-m.webp"
            : "/assets/images/big-7-draws/banner-halloween-d.webp"
        }
        // src={isMobile ? "/assets/images/big-7-draws/banner-m.webp" : "/assets/images/big-7-draws/banner-d.webp"}
        alt="Halloween Mega Draws"
        // alt="Main Banner"
        width={360}
        height={582}
        className="absolute inset-0 size-full object-cover object-top"
      />
      <div className={"relative w-full max-w-[1320px] mx-auto flex flex-col gap-6 lg:gap-10"}>
        <div className={"flex flex-col items-center lg:items-start"}>
          <div
            className={`mb-3 inline-flex min-h-5 lg:min-h-6 justify-center items-center gap-2.5 rounded border border-black/8 bg-gradient-botb px-1.5 lg:px-2 border-solid`}>
            <span
              className={
                "text-white font-jost text-[11px] lg:text-sm font-medium leading-3.5 lg:leading-5 whitespace-nowrap"
              }>
              {isEndState ? (
                <span>🎉 GRAND FINALE WINNERS REVEALED 🎉</span>
              ) : (
                <>
                  <span>NEXT DRAW IN</span>{" "}
                  {timer.isPastADay ? (
                    <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>{daysLabel}</span>
                  ) : (
                    <>
                      <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>{timer.hours}</span>
                      <span>h : </span>
                      <span className={"min-w-3.5 lg:min-w-4.5 inline-flex justify-end text-right"}>
                        {timer.minutes}
                      </span>
                      <span>m : </span>
                      <span className={"min-w-3.5 lg:min-w-4.5 inline-flex"}>{timer.seconds}</span>
                      <span className={"min-w-3 lg:min-w-3.5 inline-flex text-[9px] lg:text-[10px] leading-none"}>
                        {milisecondsT}
                      </span>
                    </>
                  )}
                </>
              )}
            </span>
          </div>

          <div className={`max-lg:text-center lg:max-w-[541px]`}>
            <div
              className={
                "text-white font-jost text-2xl font-bold leading-7.5 mb-1.5 lg:mb-3 lg:text-[40px] lg:leading-[48px]"
              }>
              {isEndState ? (
                <>
                  Halloween Mega Draws
                  {/* Summer Daily Draws - More <br className="max-lg:hidden" /> Than £10,000 Daily */}
                  <br />
                  The Results Are In!
                </>
              ) : (
                <>
                  Halloween Mega Draws
                  {/* Summer Daily Draws - More <br className="max-lg:hidden" /> Than £10,000 Daily */}
                </>
              )}
            </div>

            <div
              className={
                "text-white/87 font-jost text-sm font-medium leading-5 lg:text-xl lg:leading-8 lg:font-normal"
              }>
              {isEndState ? (
                "The draws are done. The winners are revelead. Check the table below to see if your name is on the list."
              ) : (
                <>
                  No tricks, just 36,000 prizes worth £185,000+! <br className="lg:hidden" />
                  Play as usual and automatically enter our daily draws and the monster Grand Finale!
                </>
              )}
              {/* "75,000 winners. 15 days. This isn’t just another summer. It’s your biggest chance to win." */}
            </div>
          </div>

          {!isEndState ? (
            <>
              <div
                className={`mt-8 lg:mt-10 ${isEndState ? (isMobile ? "hidden" : "invisible") : ""} ${isRaffleLoading ? "blur-lg opacity-10" : ""}`}>
                <Steps />
              </div>

              <div
                className={`mt-8 lg:mt-10 ${isEndState ? (isMobile ? "hidden" : "invisible") : ""} ${isRaffleLoading ? "blur-lg opacity-10" : ""}`}>
                <ButtonBanner />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TombolaTopRender;
